import { render } from "./CajPerkhidmatan.vue?vue&type=template&id=c3190aaa"
import script from "./CajPerkhidmatan.vue?vue&type=script&lang=js"
export * from "./CajPerkhidmatan.vue?vue&type=script&lang=js"

import "./CajPerkhidmatan.vue?vue&type=style&index=0&id=c3190aaa&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__